import { KeyRound } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { formatDateTime } from '../format';
import type { McpCreatedToken } from '../types';
import { CodeSnippet } from './copy-button';
import { ScopeBadges } from './token-badges';

interface TokenCreatedDialogProps {
  created: McpCreatedToken | null;
  onClose: () => void;
}

/** Одноразовый показ созданного токена и готовых команд подключения. */
export function TokenCreatedDialog({ created, onClose }: TokenCreatedDialogProps) {
  return (
    <Dialog
      open={created !== null}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <KeyRound className="h-5 w-5" /> Токен создан
          </DialogTitle>
          <DialogDescription>
            {created ? `Истекает ${formatDateTime(created.expiresAt)}` : null}
          </DialogDescription>
          {created ? <ScopeBadges scopes={created.scopes} /> : null}
        </DialogHeader>

        {created ? (
          <div className="space-y-4">
            <Alert variant="destructive">
              <AlertDescription>
                Скопируйте токен сейчас — он больше не будет показан. Если потеряете, отзовите его и создайте новый.
              </AlertDescription>
            </Alert>
            <CodeSnippet title="Токен" value={created.token} />
            <CodeSnippet title="Claude Code" value={created.snippets.claudeCode} />
            <CodeSnippet title="Claude Code — прямой режим" value={created.snippets.claudeCodeDirect} />
            <CodeSnippet title="JSON-конфиг" value={created.snippets.jsonConfig} />
          </div>
        ) : null}

        <DialogFooter>
          <Button onClick={onClose}>Я сохранил токен</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
